// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__2lZZA","header":"Layout_header__UdEGS","hcontent":"Layout_hcontent__3IE5t","footer":"Layout_footer__-cjJQ"};